import { useCallback } from "react";
import {
  transformToFloat,
  transformToFormatted,
} from "../../../../../../../../../lib/transformToFloat";

export const useTransformRequest = (isRequest: boolean = true) => {
  const transform = useCallback(
    (data: any) => {
      ["amount"].forEach(
        (prop: string) => {
          data[prop] = isRequest
            ? transformToFloat(data[prop]) || 0
            : transformToFormatted(data[prop]) || "0.00";
        }
      );
      // override fee amount and tax can be null, so we need to handle that case
      ["overrideFeeAmount", "overrideFeeTax"].forEach(
        (prop: string) => {
          data[prop] = isRequest
              ? transformToFloat(data[prop])
              : transformToFormatted(data[prop], undefined, false);
        }
      );
    },
    [isRequest]
  );

  return { transform };
};
